// extracted by mini-css-extract-plugin
var _1 = "AuthHeader-modulebox__dJehV";
var _2 = "AuthHeader-moduleheader__NQ8xj";
var _3 = "AuthHeader-moduleheaderContainer__EhaYA";
var _4 = "AuthHeader-moduleidwellLogo__O0Los";
var _5 = "AuthHeader-modulelink__oHqme";
var _6 = "AuthHeader-modulelogo__Podhk";
var _7 = "AuthHeader-moduletext__zZOCU";
export { _1 as "box", _2 as "header", _3 as "headerContainer", _4 as "idwellLogo", _5 as "link", _6 as "logo", _7 as "text" }
